import { IWagonEventCreate, IWagonEventDetail } from "../../types/wagonEvent";
import { numberToWasteType, wasteTypeToNumber } from "../../utils/enumMapping";
import { dayOfWeekArray, NotificationsType, wagonEventPeriodicityArray, WasteType } from "../../utils/enums";
import { IWagonEventUpdateRequest, IWagonsEventResponseWithNotification } from "../wagonEventDetailReducer";

export const adaptPostRequestForBackend = (requestObject: IWagonEventCreate) => {
  let notification: any = undefined;

  if (requestObject.notificationsType !== NotificationsType.regular) {
    notification = {
      Type: requestObject.notificationsType,
      Message: requestObject.notificationText,
    };
  }

  return {
    ...requestObject,
    wasteType: wasteTypeToNumber.get(requestObject.wasteType),
    periodicity: wagonEventPeriodicityArray.indexOf(requestObject.periodicity),
    notification,
  };
};

export const adaptResponseForFronted = (responseObject: IWagonsEventResponseWithNotification): IWagonEventDetail => {
  return {
    ...responseObject,
    wasteType: numberToWasteType.get(responseObject.wasteType) ?? WasteType.mixed,
    periodicity: wagonEventPeriodicityArray[responseObject.periodicity],
    dayOfWeek: dayOfWeekArray[responseObject.dayOfWeek],
    date: responseObject.date,
    notificationsType: responseObject.notification?.type ?? NotificationsType.regular,
    notificationText: responseObject.notification?.message ?? "",
    notificationId: responseObject.notification?.notificationId,
  };
};

export const adaptPatchRequestForBackend = (requestObject: IWagonEventDetail): IWagonEventUpdateRequest => {
  let resultBody: IWagonEventUpdateRequest = {
    date: requestObject.date,
    wasteType: wasteTypeToNumber.get(requestObject.wasteType),
  };

  if (requestObject.notificationId || requestObject.notificationsType !== NotificationsType.regular) {
    resultBody = {
      ...resultBody,
      notification: {
        Type: requestObject.notificationsType,
        Message: requestObject.notificationText,
      },
    };
  }

  return resultBody;
};
